// React libs
import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
// Services
import MapService from '../Services/MapService';
// Types
import * as CoreTypes from '../../../../Core/Data/Models/Core.type';
import * as MapTypes from '../Models/Map.type';
// Common
import CoreCommon from '../../../../Core/Resources/Common';

export interface IGetPoiTypesHook
  extends CoreTypes.IHook<MapTypes.IPoiType[]> {}

const usePoiTypes = (type?: 'project' | 'resource'): IGetPoiTypesHook => {
  // Variables
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(['common']);

  // State
  const [data, setData]: [MapTypes.IPoiType[], Function] = useState([]);
  const [isLoading, setIsLoading]: [boolean, Function] = useState(false);

  // Effects
  useEffect(() => {
    const getPoiTypes = () => {
      const restrictions = {
        project: (t: MapTypes.IPoiType) => t.isProject,
        resource: (t: MapTypes.IPoiType) => !t.isProject,
      };
      setIsLoading(true);
      MapService.getPoiTypes()
        .then((data: MapTypes.IPoiTypesData) => {
          const newData = data.data.filter((t: MapTypes.IPoiType) => {
            return type && Object.keys(restrictions).includes(type)
              ? restrictions[type](t)
              : true;
          });
          setData(newData);
          setIsLoading(false);
        })
        .catch((e: CoreTypes.IWsException) => {
          enqueueSnackbar(
            e?.error?.message || t('common:errors.defaultMessage'),
            {
              ...CoreCommon.Constantes.snackbarDefaultProps,
              variant: 'error',
            }
          );
          setIsLoading(false);
        });
    };
    getPoiTypes();
  }, [enqueueSnackbar, t, type]);

  return { data, isLoading };
};

export default usePoiTypes;
